<template>
  <div class="border border-[#E5E5E5] rounded-2xl p-[1.5rem] bg-white shadow-sm">
    <h2 class="font-medium text-2xl text-black mb-[1rem]">
      Catatan Internal Admin
    </h2>
    <BFormTextarea
      v-model="internalNote"
      placeholder="Tambahkan catatan internal di sini... (Maks 200 karakter)"
      rows="3"
      maxlength="200"
      :disabled="data.status.code === 'CANCELLED'"
      class="w-full rounded-xl border border-[#E5E5E5] p-3 text-sm focus:outline-none focus:border-[#EC5A24]"
    />
    <div class="flex items-center justify-between text-sm text-[#A3A3A3] mt-2">
      <span>Hanya terlihat oleh tim internal.</span>
      <span>{{ internalNote ? internalNote.length : 0 }}/200</span>
    </div>
    <div class="flex justify-end mt-4">
      <BButton
        variant="primary"
        :disabled="isLoadingSave || data.status.code === 'CANCELLED'"
        class="bg-[#EC5A24] border-0 text-white font-medium px-5 py-2 text-sm shadow-sm"
        @click="handleSaveNote"
      >
        <BSpinner
          v-if="isLoadingSave"
          small
          class="me-1"
        />
        Simpan Catatan
      </BButton>
    </div>
  </div>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { showSuccess, showError } from '../../config'

export default {
  name: 'InternalNoteCard',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      internalNote: '',
      isLoadingSave: false,
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val && val.admin_notes !== undefined) {
          this.internalNote = val.admin_notes || ''
        }
      },
    },
  },
  methods: {
    async handleSaveNote() {
      if (!this.data.id) return

      try {
        this.isLoadingSave = true
        const url = `/v1/partner_assignment_requests/${this.data.id}/notes`
        await komtimAxiosIns.put(url, {
          admin_notes: this.internalNote,
        })
        showSuccess({ title: 'Catatan Internal Berhasil Disimpan!' })
        this.$emit('saved')
      } catch {
        showError({ title: 'Gagal Menyimpan Catatan Internal!' })
      } finally {
        this.isLoadingSave = false
      }
    },
  },
}
</script>
